import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { ICommitmentAddEditRequest } from '../../../../model/sge/commitment/request/commitment-add-edit-request';
import { ICommitmentPagedRequest } from '../../../../model/sge/commitment/request/commitment-paged-request';
import { ICommitmentResponse } from '../../../../model/sge/commitment/response/commitment-response';

const basePath = (amendmentId: number) => `Amendment/${amendmentId}/Commitments`;

const list = async (amendmentId: number, params: Omit<ICommitmentPagedRequest, 'amendmentId'>): Promise<Pagination<ICommitmentResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(amendmentId)}`,
        params
    }).then((response) => Object.assign(new Pagination<ICommitmentResponse>(), response.data));
};

const getById = async (amendmentId: number, id: number): Promise<ICommitmentResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(amendmentId)}/${id}`
    }).then((response) => response.data);
};

const add = async (amendmentId: number, params: ICommitmentAddEditRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'post',
        url: `/${basePath(amendmentId)}`,
        data: params
    });
};

const edit = async (amendmentId: number, id: number, params: ICommitmentAddEditRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${basePath(amendmentId)}/${id}`,
        data: params
    });
};

const remove = async (amendmentId: number, id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${basePath(amendmentId)}/${id}`
    });
};

const CommitmentAppService = { list, getById, add, edit, remove };
export default CommitmentAppService;
